<template>
  <div>
    <div v-if="$vuetify.breakpoint.mdAndUp" class="d-flex">
      <div v-for="(crumb,r) in crumbs" :key="r">
        
        <v-btn v-if="r+1 < crumbs.length" text color="white" depressed dark small :to="crumb.path">{{crumb.name}}</v-btn>
        <v-btn @click="reload" v-else text color="white" depressed dark small>{{crumb.name}}</v-btn>

        <v-icon v-if="r+1 < crumbs.length">mdi-chevron-right</v-icon>
      </div>
    </div>
    <span v-else-if="!!lastCrumb" >{{lastCrumb.name}}</span>
  </div>
</template>

<script>

export default {
  name: 'BreadCrumb',
  computed : {
    lastCrumb()
    {
      return this.crumbs && this.crumbs.length > 0 ? this.crumbs[this.crumbs.length - 1] : null;
    },
    crumbs()
    {
      return (this.$route) ? this.$route.matched.map(r => {
        var path = r.path;
        for(var k in this.$route.params)
        {
          path = path.split(`:${k}`).join(this.$route.params[k]);
        }
        return {
          name : r.name,
          path : path
        }
      }) : [];

    },

  },
  data()
  {
    return {
      routes : null,
    }
  },
  methods : {
    reload()
    {
      window.document.location.reload();
    }
  }
}
</script>

<style scoped lang="scss">
</style>
